export default {
	hr: {
		global: {
			bookNow: 'Rezerviraj',
			gallery: 'Galerija slika',
			locationTitle: 'Lokacija i kontakt informacije',
			postedOn: 'Objavljeno na',
			apartment: 'Apartman',
			apartments: 'Apartmani',
			any: 'Svejedno',
		},
		apartments: {
			lobster: 'Lobster',
			lavender: 'Lavender',
			sea: 'Sea',
			olive: 'Olive',
			gallery: 'Galerija',

			text: {
				lobster: 'Studio za dvije osobe sa prekrasnom terasom i pogledom na more.',
				lavender: 'Apartman za 2+2 osobe sa spavaćom sobom, kupaonom sa tušem i WC-om, kuhinjom i prekrasnom terasom s pogledom na more.',
				sea: 'Apartman za 4 osobe sa dvije spavaće sobe, dvije kupaone sa tušom i WC-om, kuhinjom i prekrasnom terasom s pogledom na more.',
				olive: 'Apartman sa velikom terasom i prekrasnim pogledom na more, dvije spavaće sobe, dnevnim boravkom, kuhinjom, kupaonom sa tušem i WC-om, te jednim posebnim WC-om.',
			},
		},
		aboutPage: {
			welcome: "Dobrodošli u Fradol apartmane",
			aboutText: "Dobrodošli u Fradol apartmane u Tučepima, smještene u prvom redu iznad plaže, koji nude savršeno iskustvo tik uz more. S kristalno čistim Jadranskim morem doslovno nekoliko koraka od vas, uživat ćete u zadivljujućim pogledima i neposrednom pristupu plaži. Naša idealna lokacija nudi savršen spoj opuštanja i avanture, a živahni grad Makarska udaljen je samo 5 km, gdje možete istraživati šarmantne ulice, vibrantne kafiće i kulturne znamenitosti. Prirodne ljepote Nacionalnog parka Biokovo također su u blizini, idealne za planinarenje i panoramske poglede. Bilo da se sunčate na plaži, istražujete okolna područja ili uživate u miru, naši apartmani pružaju savršeno polazište za vaš nezaboravan odmor u Hrvatskoj.",
		},
		discover: {
			suggesting: "Preporučujemo posjetiti",
		},
		request: {
			title: "Pošaljite upit za rezervaciju",
			name: "Ime",
			email: "Email",
			guests: "Broj gostiju",
			checkInOut: "Dolazak/Odlazak",
			message: "Poruka (opcionalno)",
			submit: "Pošalji",
			sending: "Slanje...",
			alreadyVisited: "Jeste li nas već posjetili?",
			leaveReview: "Ostavite recenziju.",
			submitted: "Hvala! Vaš upit je poslan.",
			error: "Došlo je do pogreške. Molimo pokušajte ponovno ili nas kontaktirajte izravno putem e-maila ili WhatsApp-a.",
			privacyPolicy: "Slanjem ovog obrasca pristajete na našu Politiku privatnosti.",
		},
		services: {
			wholeApartment: 'Cijeli apartman',
			squareMeters: '90 kvadratnih metara',
			freeParking: '1 parkirno mjesto',
			freeWifi: 'Besplatan WiFi',
			petFriendly: 'Domaći ljubimci dozvoljeni',
			familyRooms: 'Obiteljske sobe',
			grill: 'Roštilj',
			noSmoking: 'Zabranjeno pušenje',
			privateOutdoorPool: 'Privatni vanjski bazen',
			washer: "Perilica rublja",
			dishWasher: "Perilica posuđa",
			microwave: "Mikrovalna pećnica",
			tv: "TV",
			airCondition: "Klima",
			seaView: "Pogled na more",
			beach: "Plaža - 5m",
			babyBed: "Dječji krevetić",
			coffeeMachine: "Aparat za kavu",
			terrace: "Terasa",
			closedLoggia: "Zatvorena loggia",
			studio: "Studio apartman",
			extraBathrooms: "2 kupaone",
		},
		reviews: {
			jarko: 'Odličan apartman i odličan domaćin, preporučujem',
			roman: 'Sjajni apartmani, domaćin je jako ljubazan i uslužan, stalno pita je li sve u redu ili vam treba pomoć, pogled s balkona je nevjerojatan, ne oklijevajte, samo rezervirajte, super cijene. Samo 1 gutljaj piva do plaže 😁 ako želite biti blizu plaže na kraju Tučepa, vrlo je blizu, a ova plaža je stvarno super. Ovdje vlada tipična obiteljska atmosfera, preporučam',
			mehmed: 'Predivno mjesto, ljubazni domaćini. Pohvale u svakom segmentu.',
			tomasz: 'Odlično mjesto, izvrsni domaćini, odlična atmosfera, prekrasno okruženje. Toplo preporučam. Pozdrav za Marina i Kristinu.',
			tranx: 'Super smještaj, na samoj šetnici, koja je uz plažu. Do plaže ima 10ak koraka...',	
		},
		rentABike: {
			title: "Rent-A-Bike",
			text: "Uz apartmane nudimo i mogućnost najma jednog ili dva sklopiva električna bicikla. Tučepi su savršeni za šetnju ili vožnju biciklom po šetnici dugoj oko 3 km, većinski skrivenoj u hladu pod borovim granama.",
		},
	},
	gb: {
		global: {
			bookNow: 'Book now',
			gallery: 'Photo gallery',
			locationTitle: 'Location & Contact information',
			postedOn: 'Posted on',
			apartment: 'Apartment',
			apartments: 'Apartments',
			any: 'Any',
		},
		apartments: {
			lobster: 'Lobster',
			lavender: 'Lavender',
			sea: 'Sea',
			olive: 'Olive',
			gallery: 'Gallery',

			text: {
				lobster: 'Studio for two with a beautiful terrace and sea view.',
				lavender: 'Apartment for 2+2 with a bedroom, bathroom with shower and toilet, kitchen and a beautiful terrace with sea view.',
				sea: 'Apartment for 4 with two bedrooms, two bathrooms with shower and toilet, kitchen and a beautiful terrace with sea view.',
				olive: 'Apartment with a large terrace and beautiful sea view, two bedrooms, living room, kitchen, bathroom with shower and toilet, and an additional separate toilet.',
			},
		},
		aboutPage: {
			welcome: "Welcome to Fradol apartments",
			aboutText: "Welcome to Fradol apartments in Tučepi, Croatia, ideally located right above the beach for the ultimate seaside experience. With the sparkling Adriatic Sea just steps away, you can enjoy breathtaking views and easy access to the crystal-clear waters. Our prime location offers the perfect blend of relaxation and adventure, with the lively town of Makarska just 5 km away, where you can explore charming streets, vibrant cafés, and cultural landmarks. The natural beauty of Biokovo National Park is also nearby, perfect for hiking and panoramic views. Whether you're soaking up the sun, exploring the surrounding area, or enjoying the tranquility of the beach, our apartments provide the ideal base for your unforgettable Croatian holiday.",
		},
		discover: {
			suggesting: "We suggest visiting",
		},
		request: {
			title: "Send a request for booking",
			name: "Name",
			email: "Email",
			guests: "Number of guests",
			checkInOut: "Check-in/out",
			message: "Message (optional)",
			submit: "Submit",
			sending: "Sending...",
			alreadyVisited: "Have you already visited us?",
			leaveReview: "Leave a review.",
			submitted: "Thank you! Your request has been submitted.",
			error: "An error occurred. Please try again or contact us directly via email or WhatsApp.",
			privacyPolicy: "By submitting this form, you agree to our Privacy Policy.",
		},
		services: {
			wholeApartment: 'Whole apartment',
			squareMeters: '90 square meters',
			freeParking: '1 parking spot',
			freeWifi: 'Free WiFi',
			petFriendly: 'Pet friendly',
			familyRooms: 'Family rooms',
			grill: 'Grill',
			noSmoking: 'No smoking',
			privateOutdoorPool: 'Private outdoor pool',
			washer: "Washer",
			dishWasher: "Dishwasher",
			microwave: "Microwave",
			tv: "TV",
			airCondition: "Air condition",
			seaView: "Sea view",
			beach: "Beach - 5m",
			babyBed: "Baby bed",
			coffeeMachine: "Coffee machine",
			terrace: "Terrace",
			closedLoggia: "Closed loggia",
			studio: "Studio apartment",
			extraBathrooms: "2 bathrooms",
		},
		reviews: {
			jarko: 'Great apartment and great host, I recommend',
			roman: 'Great apartments, the host is very kind and helpful, constantly asking if everything is okay or if you need help, the view from the balcony is amazing, do not hesitate, just book, great prices. Only 1 sip of beer to the beach 😁 if you want to be close to the beach at the end of Tučepi, it is very close, and this beach is really great. There is a typical family atmosphere here, I recommend',
			mehmed: 'Wonderful place, kind hosts. Praise in every segment.',
			tomasz: 'Great place, excellent hosts, great atmosphere, beautiful surroundings. I highly recommend. Greetings to Marin and Kristina.',
			tranx: 'Great accommodation, right on the promenade, which is next to the beach. There are about 10 steps to the beach...',
		},
		rentABike: {
			title: "Rent-A-Bike",
			text: "With the apartments, we offer the possibility of renting one or two folding electric bikes. Tučepi is perfect for walking or cycling along the 3 km long promenade, mostly hidden in the shade under pine branches.",
		},
	},
	de: {
		global: {
			bookNow: 'Jetzt buchen',
			gallery: 'Fotogalerie',
			locationTitle: 'Standort & Kontaktinformationen',
			postedOn: 'Veröffentlicht auf',
			apartment: 'Apartment',
			apartments: 'Apartments',
			any: 'Egal',
		},
		apartments: {
			lobster: 'Lobster',
			lavender: 'Lavender',
			sea: 'Sea',
			olive: 'Olive',
			gallery: 'Galerie',

			text: {
				lobster: 'Studio für zwei Personen mit einer schönen Terrasse und Meerblick.',
				lavender: 'Apartment für 2+2 Personen mit einem Schlafzimmer, Bad mit Dusche und WC, Küche und einer schönen Terrasse mit Meerblick.',
				sea: 'Apartment für 4 Personen mit zwei Schlafzimmern, zwei Bädern mit Dusche und WC, Küche und einer schönen Terrasse mit Meerblick.',
				olive: 'Apartment mit großer Terrasse und wunderschönem Meerblick, zwei Schlafzimmern, Wohnzimmer, Küche, Bad mit Dusche und WC und einem zusätzlichen separaten WC.',
			},
		},
		aboutPage: {
			welcome: "Willkommen in den Fradol Apartments",
			aboutText: "Willkommen in den Fradol Apartments in Tučepi, Kroatien, ideal gelegen direkt über dem Strand für das ultimative Seebaderlebnis. Mit dem funkelnden Adriatischen Meer nur wenige Schritte entfernt, können Sie atemberaubende Ausblicke und einfachen Zugang zu den kristallklaren Gewässern genießen. Unsere erstklassige Lage bietet die perfekte Mischung aus Entspannung und Abenteuer, mit der lebhaften Stadt Makarska nur 5 km entfernt, wo Sie charmante Straßen, lebendige Cafés und kulturelle Sehenswürdigkeiten erkunden können. Die natürliche Schönheit des Biokovo-Nationalparks ist ebenfalls in der Nähe, ideal zum Wandern und für Panoramablicke. Ob Sie die Sonne genießen, die Umgebung erkunden oder die Ruhe des Strandes genießen, unsere Apartments bieten die ideale Basis für Ihren unvergesslichen kroatischen Urlaub.",
		},
		discover: {
			suggesting: "Wir empfehlen einen Besuch",
		},
		request: {
			title: "Senden Sie eine Buchungsanfrage",
			name: "Name",
			email: "Email",
			guests: "Anzahl der Gäste",
			checkInOut: "Check-in/out",
			message: "Nachricht (optional)",
			submit: "Absenden",
			sending: "Senden...",
			alreadyVisited: "Haben Sie uns bereits besucht?",
			leaveReview: "Hinterlassen Sie eine Bewertung.",
			submitted: "Vielen Dank! Ihre Anfrage wurde gesendet.",
			error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt per E-Mail oder WhatsApp.",
			privacyPolicy: "Durch Absenden dieses Formulars stimmen Sie unserer Datenschutzrichtlinie zu.",
		},
		services: {
			wholeApartment: 'Ganze Wohnung',
			squareMeters: '90 Quadratmeter',
			freeParking: '1 Parkplatz',
			freeWifi: 'Kostenloses WLAN',
			petFriendly: 'Haustiere erlaubt',
			familyRooms: 'Familienzimmer',
			grill: 'Grill',
			noSmoking: 'Rauchen verboten',
			privateOutdoorPool: 'Privater Außenpool',
			washer: "Waschmaschine",
			dishWasher: "Geschirrspüler",
			microwave: "Mikrowelle",
			tv: "Fernseher",
			airCondition: "Klimaanlage",
			seaView: "Meerblick",
			beach: "Strand - 5m",
			babyBed: "Babybett",
			coffeeMachine: "Kaffeemaschine",
			terrace: "Terrasse",
			closedLoggia: "Geschlossene Loggia",
			studio: "Studio-Apartment",
			extraBathrooms: "2 Badezimmer",
		},
		reviews: {
			jarko: 'Tolle Wohnung und toller Gastgeber, ich empfehle',
			roman: 'Tolle Apartments, der Gastgeber ist sehr nett und hilfsbereit, fragt ständig, ob alles in Ordnung ist oder ob Sie Hilfe benötigen, die Aussicht vom Balkon ist erstaunlich, zögern Sie nicht, buchen Sie einfach, tolle Preise. Nur 1 Schluck Bier zum Strand 😁 wenn Sie am Ende von Tučepi in der Nähe des Strandes sein möchten, ist es sehr nah, und dieser Strand ist wirklich toll. Hier herrscht eine typische familiäre Atmosphäre, ich empfehle',
			mehmed: 'Wunderbarer Ort, nette Gastgeber. Lob in jedem Segment.',
			tomasz: 'Toller Ort, ausgezeichnete Gastgeber, tolle Atmosphäre, schöne Umgebung. Ich empfehle es sehr. Grüße an Marin und Kristina.',
			tranx: 'Tolle Unterkunft, direkt an der Promenade, die neben dem Strand liegt. Es sind etwa 10 Schritte zum Strand...',
		},
		rentABike: {
			title: "Rent-A-Bike",
			text: "Zu den Apartments bieten wir die Möglichkeit, ein oder zwei faltbare Elektrofahrräder zu mieten. Tučepi eignet sich perfekt zum Spazierengehen oder Radfahren entlang der etwa 3 km langen Promenade, die größtenteils im Schatten unter Kiefernzweigen versteckt ist.",
		},
	},
	it: {
		global: {
			bookNow: 'Prenota ora',
			gallery: 'Galleria fotografica',
			locationTitle: 'Posizione e informazioni di contatto',
			postedOn: 'Pubblicato su',
			apartment: 'Appartamento',
			apartments: 'Appartamenti',
			any: 'Qualsiasi',
		},
		apartments: {
			lobster: 'Lobster',
			lavender: 'Lavender',
			sea: 'Sea',
			olive: 'Olive',
			gallery: 'Galleria',

			text: {
				lobster: 'Monolocale per due persone con una bellissima terrazza e vista sul mare.',
				lavender: 'Appartamento per 2+2 con una camera da letto, bagno con doccia e WC, cucina e una bellissima terrazza con vista sul mare.',
				sea: 'Appartamento per 4 persone con due camere da letto, due bagni con doccia e WC, cucina e una bellissima terrazza con vista sul mare.',
				olive: 'Appartamento con ampia terrazza e splendida vista sul mare, due camere da letto, soggiorno, cucina, bagno con doccia e WC e un ulteriore WC separato.',
			},
		},
		aboutPage: {
			welcome: "Benvenuti negli appartamenti Fradol",
			aboutText: "Benvenuti negli appartamenti Fradol a Tučepi, Croazia, ideali situati proprio sopra la spiaggia per l'esperienza balneare definitiva. Con il luccicante Mar Adriatico a pochi passi, potrete godere di viste mozzafiato e di facile accesso alle acque cristalline. La nostra posizione privilegiata offre il perfetto equilibrio tra relax e avventura, con la vivace città di Makarska a soli 5 km di distanza, dove potrete esplorare strade affascinanti, vivaci caffè e luoghi culturali. Anche la bellezza naturale del Parco Nazionale Biokovo è nelle vicinanze e perfetta per escursioni e viste panoramiche. Che siate alla ricerca di sole, di esplorare la zona circostante o di godervi la tranquillità della spiaggia, i nostri appartamenti offrono la base ideale per la vostra indimenticabile vacanza in Croazia.",
		},
		discover: {
			suggesting: "Suggeriamo di visitare",
		},
		request: {
			title: "Invia una richiesta di prenotazione",
			name: "Nome",
			email: "Email",
			guests: "Numero di ospiti",
			checkInOut: "Check-in/out",
			message: "Messaggio (opzionale)",
			submit: "Invia",
			sending: "Invio...",
			alreadyVisited: "Ci avete già visitato?",
			leaveReview: "Lascia una recensione.",
			submitted: "Grazie! La tua richiesta è stata inviata.",
			error: "Si è verificato un errore. Riprova o contattaci direttamente via email o WhatsApp.",
			privacyPolicy: "Inviando questo modulo, accetti la nostra Informativa sulla privacy.",
		},
		services: {
			wholeApartment: 'Intero appartamento',
			squareMeters: '90 metri quadrati',
			freeParking: '1 posto auto',
			freeWifi: 'WiFi gratuito',
			petFriendly: 'Animali ammessi',
			familyRooms: 'Camere familiari',
			grill: 'Barbecue',
			noSmoking: 'Vietato fumare',
			privateOutdoorPool: 'Piscina privata all\'aperto',
			washer: "Lavatrice",
			dishWasher: "Lavastoviglie",
			microwave: "Forno a microonde",
			tv: "TV",
			airCondition: "Aria condizionata",
			seaView: "Vista sul mare",
			beach: "Spiaggia - 5m",
			babyBed: "Lettino per bambini",
			coffeeMachine: "Macchina da caffè",
			terrace: "Terrazza",
			closedLoggia: "Loggia chiusa",
			studio: "Monolocale",
			extraBathrooms: "2 bagni",
		},
		reviews: {
			jarko: 'Ottimo appartamento e ottimo host, consiglio',
			roman: 'Ottimi appartamenti, l\'host è molto gentile e disponibile, chiede costantemente se tutto va bene o se hai bisogno di aiuto, la vista dal balcone è incredibile, non esitare, prenota subito, ottimi prezzi. Solo 1 sorso di birra per la spiaggia 😁 se vuoi essere vicino alla spiaggia alla fine di Tučepi, è molto vicino, e questa spiaggia è davvero fantastica. Qui c\'è un\'atmosfera familiare tipica, consiglio',
			mehmed: 'Posto meraviglioso, ospiti gentili. Lode in ogni segmento.',
			tomasz: 'Posto fantastico, ottimi padroni di casa, ottima atmosfera, splendidi dintorni. Lo consiglio vivamente. Saluti a Marin e Kristina.',
			tranx: 'Ottimo alloggio, proprio sul lungomare, che è accanto alla spiaggia. Ci sono circa 10 passi per arrivare in spiaggia...',
		},
		rentABike: {
			title: "Rent-A-Bike",
			text: "Con gli appartamenti, offriamo la possibilità di noleggiare una o due biciclette elettriche pieghevoli. Tučepi è perfetta per passeggiare o andare in bicicletta lungo il lungomare lungo circa 3 km, per lo più nascosto all'ombra sotto i rami di pino.",
		},
	},
	pl: {
		global: {
			bookNow: 'Zarezerwuj teraz',
			gallery: 'Galeria zdjęć',
			locationTitle: 'Lokalizacja i informacje kontaktowe',
			postedOn: 'Opublikowano na',
			apartment: 'Apartament',
			apartments: 'Apartamenty',
			any: 'Dowolny',
		},
		apartments: {
			lobster: 'Lobster',
			lavender: 'Lavender',
			sea: 'Sea',
			olive: 'Olive',
			gallery: 'Galeria',

			text: {
				lobster: 'Studio dla dwóch osób z pięknym tarasem i widokiem na morze.',
				lavender: 'Apartament dla 2+2 osób z sypialnią, łazienką z prysznicem i toaletą, kuchnią i pięknym tarasem z widokiem na morze.',
				sea: 'Apartament dla 4 osób z dwiema sypialniami, dwoma łazienkami z prysznicem i toaletą, kuchnią i pięknym tarasem z widokiem na morze.',
				olive: 'Apartament z dużym tarasem i pięknym widokiem na morze, dwiema sypialniami, salonem, kuchnią, łazienką z prysznicem i toaletą oraz dodatkowym oddzielnym WC.',
			},
		},
		aboutPage: {
			welcome: "Witaj w apartamentach Fradol",
			aboutText: "Witaj w apartamentach Fradol w Tučepi, Chorwacja, idealnie położonych tuż nad plażą dla ostatecznego doświadczenia nadmorskiego. Z błyszczącym Adriatykiem zaledwie kilka kroków od Ciebie, możesz cieszyć się zapierającymi dech w piersiach widokami i łatwym dostępem do krystalicznie czystych wód. Nasza doskonała lokalizacja oferuje idealną mieszankę relaksu i przygody, z żywym miastem Makarska zaledwie 5 km stąd, gdzie możesz zwiedzać urocze uliczki, tętniące kawiarnie i zabytki kultury. Naturalne piękno Parku Narodowego Biokovo jest również w pobliżu, idealne do wędrówek i panoramicznych widoków. Czy opalasz się na słońcu, zwiedzasz okolicę czy cieszysz się spokojem plaży, nasze apartamenty zapewniają idealną bazę dla niezapomnianych wakacji w Chorwacji.",
		},
		discover: {
			suggesting: "Sugerujemy odwiedzenie",
		},
		request: {
			title: "Wyślij zapytanie o rezerwację",
			name: "Imię",
			email: "Email",
			guests: "Liczba gości",
			checkInOut: "Zameldowanie/Wymeldowanie",
			message: "Wiadomość (opcjonalnie)",
			submit: "Wyślij",
			sending: "Wysyłanie...",
			alreadyVisited: "Czy już nas odwiedziłeś?",
			leaveReview: "Napisz recenzję.",
			submitted: "Dziękujemy! Twoje zapytanie zostało wysłane.",
			error: "Wystąpił błąd. Spróbuj ponownie lub skontaktuj się z nami bezpośrednio za pomocą e-maila lub WhatsApp.",
			privacyPolicy: "Wysyłając ten formularz, zgadzasz się na naszą Politykę prywatności.",
		},
		services: {
			wholeApartment: 'Cały apartament',
			squareMeters: '90 metrów kwadratowych',
			freeParking: '1 miejsce parkingowe',
			freeWifi: 'Bezpłatne WiFi',
			petFriendly: 'Zwierzęta domowe są akceptowane',
			familyRooms: 'Pokoje rodzinne',
			grill: 'Grill',
			noSmoking: 'Zakaz palenia',
			privateOutdoorPool: 'Prywatny basen zewnętrzny',
			washer: "Pralka",
			dishWasher: "Zmywarka",
			microwave: "Kuchenka mikrofalowa",
			tv: "Telewizor",
			airCondition: "Klimatyzacja",
			seaView: "Widok na morze",
			beach: "Plaża - 5m",
			babyBed: "Łóżeczko dla dziecka",
			coffeeMachine: "Ekspres do kawy",
			terrace: "Taras",
			closedLoggia: "Zamknięta loggia",
			studio: "Apartament typu studio",
			extraBathrooms: "2 łazienki",
		},
		reviews: {
			jarko: 'Świetny apartament i świetny gospodarz, polecam',
			roman: 'Świetne apartamenty, gospodarz jest bardzo miły i pomocny, ciągle pyta, czy wszystko jest w porządku, czy potrzebujesz pomocy, widok z balkonu jest niesamowity, nie wahaj się, po prostu zarezerwuj, świetne ceny. Tylko 1 łyk piwa do plaży 😁 jeśli chcesz być blisko plaży na końcu Tučepi, jest bardzo blisko, a ta plaża jest naprawdę świetna. Tutaj panuje typowa rodzinna atmosfera, polecam',
			mehmed: 'Cudowne miejsce, mili gospodarze. Pochwała w każdym segmencie.',
			tomasz: 'Świetne miejsce, doskonali gospodarze, wspaniała atmosfera, piękne otoczenie. Gorąco polecam. Pozdrowienia dla Marina i Kristiny.',
			tranx: 'Świetne zakwaterowanie, tuż przy promenadzie, która jest obok plaży. Do plaży jest około 10 kroków...',
		},
		rentABike: {
			title: "Wynajem rowerów",
			text: "Wraz z apartamentami oferujemy możliwość wynajęcia jednego lub dwóch składanych rowerów elektrycznych. Tučepi są idealne do spacerów lub jazdy rowerem wzdłuż około 3 km długiej promenady, w większości ukrytej w cieniu pod gałęziami sosny.",
		},
	},
	sk: {
		global: {
			bookNow: 'Rezervovať teraz',
			gallery: 'Fotogaléria',
			locationTitle: 'Lokalita a kontaktné informácie',
			postedOn: 'Zverejnen é',
			apartment: 'Apartmán',
			apartments: 'Apartmány',
			any: 'Akýkoľvek',
		},
		apartments: {
			lobster: 'Lobster',
			lavender: 'Lavender',
			sea: 'Sea',
			olive: 'Olive',
			gallery: 'Galéria',

			text: {
				lobster: 'Štúdio pre dve osoby s krásnou terasou a výhľadom na more.',
				lavender: 'Apartmán pre 2+2 osoby s jedálňou, kúpeľňou so sprchou a WC, kuchyňou a krásnou terasou s výhľadom na more.',
				sea: 'Apartmán pre 4 osoby s dvoma spálňami, dvoma kúpeľňami so sprchou a WC, kuchyňou a krásnou terasou s výhľadom na more.',
				olive: 'Apartmán s veľkou terasou a krásnym výhľadom na more, dvoma spálňami, obývacou izbou, kuchyňou, kúpeľňou so sprchou a WC a ďalším samostatným WC.',
			},
		},
		aboutPage: {
			welcome: "Vitajte v apartmánoch Fradol",
			aboutText: "Vitajte v apartmánoch Fradol v Tučepi, Chorvátsko, ideálne situovaných priamo nad plážou pre konečný zážitok pri mori. S blyštivým Jadranom len pár krokov od vás si môžete vychutnať dychberúce výhľady a ľahký prístup k krištáľovo čistým vodám. Naša výborná poloha ponúka dokonalú rovnováhu medzi relaxom a dobrodružstvom, s živým mestom Makarska len 5 km odtiaľ, kde môžete objavovať očarujúce uličky, živé kaviarne a kultúrne pamiatky. Prirodzená krása Národného parku Biokovo je tiež v blízkosti, ideálna na turistiku a panoramatické výhľady. Či už sa opaľujete na slnku, objavujete okolité oblasti alebo si užívate pokoj pláže, naše apartmány poskytujú ideálnu základňu pre vašu nezabudnuteľnú dovolenku v Chorvátsku.",
		},
		discover: {
			suggesting: "Odporúčame navštíviť",
		},
		request: {
			title: "Pošlite žiadosť o rezerváciu",
			name: "Meno",
			email: "Email",
			guests: "Počet hostí",
			checkInOut: "Check-in/out",
			message: "Správa (voliteľné)",
			submit: "Odoslať",
			sending: "Odosielanie...",
			alreadyVisited: "Už ste nás navštívili?",
			leaveReview: "Napíšte recenziu.",
			submitted: "Ďakujeme! Vaša žiadosť bola odoslaná.",
			error: "Došlo k chybe. Skúste to znova alebo nás kontaktujte priamo e-mailom alebo WhatsApp.",
			privacyPolicy: "Odoslaním tohto formulára súhlasíte s našimi zásadami ochrany osobných údajov.",
		},
		services: {
			wholeApartment: 'Celý apartmán',
			squareMeters: '90 metrov štvorcových',
			freeParking: '1 parkovacie miesto',
			freeWifi: 'WiFi zdarma',
			petFriendly: 'Domáce zvieratá povolené',
			familyRooms: 'Rodinné izby',
			grill: 'Gril',
			noSmoking: 'Fajčenie zakázané',
			privateOutdoorPool: 'Súkromný vonkajší bazén',
			washer: "Práčka",
			dishWasher: "Umývačka riadu",
			microwave: "Mikrovlnná rúra",
			tv: "TV",
			airCondition: "Klimatizácia",
			seaView: "Výhľad na more",
			beach: "Pláž - 5m",
			babyBed: "Detská postieľka",
			coffeeMachine: "Kávovar",
			terrace: "Terasa",
			closedLoggia: "Zatvorená loggia",
			studio: "Štúdio apartmán",
			extraBathrooms: "2 kúpeľne",
		},
		reviews: {
			jarko: 'Skvelý apartmán a skvelý hostiteľ, odporúčam',
			roman: 'Skvelé apartmány, hostiteľ je veľmi milý a ochotný, neustále sa pýta, či je všetko v poriadku alebo či potrebujete pomoc, výhľad z balkóna je úžasný, neváhajte, len rezervujte, skvelé ceny. Len 1 dúšok piva na pláž 😁 ak chcete byť blízko pláže na konci Tučepi, je to veľmi blízko a táto pláž je naozaj skvelá. Tu panuje typická rodinná atmosféra, odporúčam',
			mehmed: 'Úžasné miesto, milí hostitelia. Chvála v každom segmente.',
			tomasz: 'Skvelé miesto, vynikajúci hostitelia, skvelá atmosféra, krásne okolie. Vrelo odporúčam. Pozdravy pre Marina a Kristinu.',
			tranx: 'Skvelé ubytovanie, priamo na promenáde, ktorá je vedľa pláže. Na pláž je asi 10 krokov...',
		},
		rentABike: {
			title: "Rent-A-Bike",
			text: "K apartmánom ponúkame možnosť prenájmu jedného alebo dvoch skladacích elektrických bicyklov. Tučepi sú ideálne na prechádzky alebo cykloturistiku pozdĺž približne 3 km dlhej promenády, väčšinou skrytej v tieni pod vetvami borovice.",
		},
	},
	cz: {
		global: {
			bookNow: 'Rezervovat nyní',
			gallery: 'Fotogalerie',
			locationTitle: 'Lokalita a kontaktní informace',
			postedOn: 'Publikováno na',
			apartment: 'Apartmán',
			apartments: 'Apartmány',
			any: 'Jakýkoliv',
		},
		apartments: {
			lobster: 'Lobster',
			lavender: 'Lavender',
			sea: 'Sea',
			olive: 'Olive',
			gallery: 'Galerie',

			text: {
				lobster: 'Studio pro dvě osoby s krásnou terasou a výhledem na moře.',
				lavender: 'Apartmán pro 2+2 s ložnicí, koupelnou se sprchou a WC, kuchyní a krásnou terasou s výhledem na moře.',
				sea: 'Apartmán pro 4 osoby s dvěma ložnicemi, dvěma koupelnami se sprchou a WC, kuchyní a krásnou terasou s výhledem na moře.',
				olive: 'Apartmán s velkou terasou a krásným výhledem na moře, dvěma ložnicemi, obývacím pokojem, kuchyní, koupelnou se sprchou a WC a dalším samostatným WC.',
			},
		},
		aboutPage: {
			welcome: "Vítejte v apartmánech Fradol",
			aboutText: "Vítejte v apartmánech Fradol v Tučepi, Chorvatsko, ideálně umístěných přímo nad pláží pro konečný pobyt u moře. S třpytivým Jaderským mořem jen pár kroků od vás si můžete vychutnat dech beroucí výhledy a snadný přístup k křišťálově čistým vodám. Naše skvělá poloha nabízí dokonalou rovnováhu mezi relaxací a dobrodružstvím, s živým městem Makarska jen 5 km odtud, kde můžete objevovat okouzlující uličky, živé kavárny a kulturní památky. Přírodní krása Národního parku Biokovo je také nedaleko, ideální pro turistiku a panoramatické výhledy. Ať už se opalujete na slunci, objevujete okolí nebo si užíváte klid pláže, naše apartmány poskytují ideální základnu pro vaši nezapomenutelnou dovolenou v Chorvatsku.",
		},
		discover: {
			suggesting: "Navrhujeme navštívit",
		},
		request: {
			title: "Pošlete žádost o rezervaci",
			name: "Jméno",
			email: "Email",
			guests: "Počet hostů",
			checkInOut: "Check-in/out",
			message: "Zpráva (volitelně)",
			submit: "Odeslat",
			sending: "Odesílání...",
			alreadyVisited: "Již jste nás navštívili?",
			leaveReview: "Napište recenzi.",
			submitted: "Děkujeme! Vaše žádost byla odeslána.",
			error: "Nastala chyba. Zkuste to znovu nebo nás kontaktujte přímo emailem nebo WhatsApp.",
			privacyPolicy: "Odesláním tohoto formuláře souhlasíte s našimi zásadami ochrany osobních údajů.",
		},
		services: {
			wholeApartment: 'Celý apartmán',
			squareMeters: '90 metrů čtverečních',
			freeParking: '1 parkovací místo',
			freeWifi: 'WiFi zdarma',
			petFriendly: 'Domácí zvířata povolena',
			familyRooms: 'Rodinné pokoje',
			grill: 'Gril',
			noSmoking: 'Kouření zakázáno',
			privateOutdoorPool: 'Soukromý venkovní bazén',
			washer: "Prádelna",
			dishWasher: "Myčka nádobí",
			microwave: "Mikrovlnná trouba",
			tv: "TV",
			airCondition: "Klimatizace",
			seaView: "Výhled na moře",
			beach: "Pláž - 5m",
			babyBed: "Dětská postýlka",
			coffeeMachine: "Kávovar",
			terrace: "Terasa",
			closedLoggia: "Zavřená lodžie",
			studio: "Studiový apartmán",
			extraBathrooms: "2 koupelny",
		},
		reviews: {
			jarko: 'Skvělý apartmán a skvělý hostitel, doporučuji',
			roman: 'Skvělé apartmány, hostitel je velmi milý a ochotný, neustále se ptá, zda je vše v pořádku nebo zda potřebujete pomoc, výhled z balkonu je úžasný, neváhejte, jen rezervujte, skvělé ceny. Jen 1 doušek piva na pláž 😁 pokud chcete být blízko pláže na konci Tučepi, je to velmi blízko a tato pláž je opravdu skvělá. Zde panuje typická rodinná atmosféra, doporučuji',
			mehmed: 'Úžasné místo, milí hostitelé. Chvála v každém segmentu.',
			tomasz: 'Skvělé místo, vynikající hostitelé, skvělá atmosféra, krásné okolí. Vřele doporučuji. Pozdravy pro Marina a Kristinu.',
			tranx: 'Skvělé ubytování, přímo na promenádě, která je vedle pláže. Na pláž je asi 10 kroků...',
		},
		rentABike: {
			title: "Rent-A-Bike",
			text: "K apartmánům nabízíme možnost pronájmu jednoho nebo dvou skládacích elektrických kol. Tučepi jsou ideální pro procházky nebo cykloturistiku podél přibližně 3 km dlouhé promenády, většinou skryté ve stínu pod větvemi borovice.",
		},
	},
};
